<template>
  <div class="relative">
    <b-table
      :items="dataFetcher.data"
      :fields="fieldsFulfillmentKomship"
      :empty-text="dataFetcher.isLoading ? '' : 'Tidak ada data yang ditampilkan.'"
      show-empty
      responsive
      class="!max-h-[50vh] !mb-0"
      sticky-header
      @scroll.native="handleScroll"
    >
      <template #cell(created_at)="data">
        <p class="mb-0">
          {{ YEAR_MONTH_DAY(data.value) }}
        </p>
        <p class="text-[#828282] mb-0">
          {{ TIME(data.value) }}
        </p>
      </template>
      <template #cell(partner_name)="data">
        <p class="mb-0">
          {{ data.value }}
        </p>
        <p class="text-[#828282] mb-0">
          {{ data.item.brand_name }}
        </p>
      </template>
      <template #cell(total_print)="data">
        <p
          :class="[
            'mb-[4px] rounded-full px-[8px] py-[2px] text-center',
            generatePackingPrintStatus(data.value, 'css'),
          ]"
        >
          {{ generatePackingPrintStatus(data.value, 'text') }}
        </p>
        <p class="text-center">
          {{ data.value }}/{{ data.item.total_order }}
        </p>
      </template>
      <template #cell(request_id)="data">
        <router-link
          :to="{ name: 'kompack-total-nilai-transaksi-fulfillment-komship-detail', params: { id: data.value } }"
          class="text-[#F95031] hover:underline"
        >
          Lihat Detail
        </router-link>
      </template>
    </b-table>
    <div
      v-if="dataFetcher.isLoading"
      class="absolute bottom-0 left-0 right-0 flex justify-center items-center p-[20px] bg-white bg-opacity-90"
    >
      <div class="flex items-center gap-2">
        <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600" />
        <span class="text-sm text-gray-600">Memuat data...</span>
      </div>
    </div>
  </div>
</template>

<script>
import { createPaginatedFetcher } from '@/@core/libs/fetch/usePaginatedFetcher'
import { YEAR_MONTH_DAY, TIME } from '@/libs/filterDate'
import { fieldsFulfillmentKomship } from '../config'

/**
 * Component untuk menampilkan data fulfillment komship
 * @component FulfillmentKomshipCard
 */
export default {
  props: {
    /** @type {Object} Date range filter { startDate, endDate } */
    period: {
      type: Object,
      required: true,
    },
    /** @type {string|null} Transaction status filter */
    status: {
      type: String,
      default: null,
    },
    /** @type {number|string|null} Selected warehouse ID */
    warehouseId: {
      type: [Number, String],
      default: null,
    },
    /** @type {number|string|null} Selected partner ID */
    partnerId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      dataFetcher: null,
    }
  },
  watch: {
    status() {
      this.handleRefreshData()
    },
    warehouseId() {
      this.handleRefreshData()
    },
    partnerId() {
      this.handleRefreshData()
    },
  },
  created() {
    this.initializeFetcher()
    this.fieldsFulfillmentKomship = fieldsFulfillmentKomship
  },
  mounted() {
    this.handleRefreshData()
  },
  methods: {
    YEAR_MONTH_DAY,
    TIME,
    /**
     * Generate packing print status badge style or label text
     * @param {number} totalPrint
     * @param {'css'|'text'} mode
     * @returns {string}
     */
    generatePackingPrintStatus(totalPrint, mode) {
      if (mode === 'css') {
        return totalPrint > 0 ? 'bg-[#BEFCDE]/50 text-[#34A770]' : 'bg-[#FCBEBE]/50 text-[#E31A1A]'
      }
      return totalPrint > 0 ? 'Diprint' : 'Belum Diprint'
    },
    /**
     * Initialize paginated fetcher for Komship fulfillment transactions
     */
    initializeFetcher() {
      const fnFetch = ({
        offset, limit, start_date, end_date, status, warehouse_id: warehouseId, partner_id: partnerId,
      }) => this.$http_new.get('/komship/api/v1/admin/orders/kompack/transaction', {
        params: {
          start_date,
          end_date,
          offset,
          limit,
          status,
          warehouse_id: warehouseId || undefined,
          partner_id: partnerId || undefined,
        },
      }).then(res => {
        const { data } = res.data
        return {
          data,
        }
      }).catch(() => ({
        data: [],
      }))

      this.dataFetcher = createPaginatedFetcher(fnFetch, 0, 50)
    },
    /**
     * Refresh data with current filters and date period
     */
    async handleRefreshData() {
      await this.dataFetcher.fetchData({
        reset: true,
        options: {
          start_date: YEAR_MONTH_DAY(this.period.startDate),
          end_date: YEAR_MONTH_DAY(this.period.endDate),
          status: this.status,
          warehouse_id: this.warehouseId || undefined,
          partner_id: this.partnerId || undefined,
        },
      })
    },
    /**
     * Handle scroll for infinite loading
     * @param {Event} event
     */
    handleScroll(event) {
      if (event.target.scrollTop + event.target.clientHeight + 500 >= event.target.scrollHeight) {
        if (this.dataFetcher.data.length <= 0) return
        this.dataFetcher.fetchData()
      }
    },
  },
}
</script>
